
import { updateAppConfig } from '#app'
import { defuFn } from '/home/homeyou/shc/build/build-headless/93418/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "nuxt": {}
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/homeyou/shc/build/build-headless/93418/app.config.ts"
import cfg1 from "/home/homeyou/shc/build/build-headless/93418/layers/nuxt-bbk-cart-layer/app.config.ts"
import cfg2 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-account-layer/app.config.ts"
import cfg3 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-catalog-page-layer/app.config.ts"
import cfg4 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-product-page-layer/app.config.ts"
import cfg5 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-layout-layer/app.config.ts"
import cfg6 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-ui-layer/app.config.ts"
import cfg7 from "/home/homeyou/shc/build/build-headless/93418/node_modules/@shc/nuxt-shc-base-layer/app.config.ts"

export default /* #__PURE__ */ defuFn(cfg0, cfg1, cfg2, cfg3, cfg4, cfg5, cfg6, cfg7, inlineConfig)
